import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "card-account-group" };
const _hoisted_2 = { class: "illustration-container" };
const _hoisted_3 = ["src", "alt"];
const _hoisted_4 = { class: "card-content" };
const _hoisted_5 = { class: "card-title" };
const _hoisted_6 = { class: "card-footer" };
const _hoisted_7 = { class: "amount" };
const _hoisted_8 = { class: "account-avatars" };
const _hoisted_9 = ["src", "alt"];
import { computed } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'CardAccountGroup',
    props: {
        cardTitle: {},
        amount: {},
        formatter: {},
        illustrationUrl: {},
        accountAvatars: {},
        backgroundColor: { default: '#fce5d4' }
    },
    setup(__props) {
        _useCssVars(_ctx => ({
            "67f6b156": (_ctx.backgroundColor)
        }));
        const props = __props;
        const formattedAmount = computed(() => {
            return props.formatter.format(props.amount);
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    (_ctx.illustrationUrl)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: _ctx.illustrationUrl,
                            alt: _ctx.cardTitle,
                            class: "illustration"
                        }, null, 8, _hoisted_3))
                        : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.cardTitle), 1),
                    _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, _toDisplayString(formattedAmount.value), 1),
                        _createElementVNode("div", _hoisted_8, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accountAvatars, (avatar, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                    key: index,
                                    class: "avatar"
                                }, [
                                    _createElementVNode("img", {
                                        src: avatar.url,
                                        alt: avatar.alt,
                                        class: "avatar-image"
                                    }, null, 8, _hoisted_9)
                                ]));
                            }), 128))
                        ])
                    ])
                ])
            ]));
        };
    }
});
